/** For a country short code, return a RegExp that can match a valid postal/zip code.
*/
export const postalCodeRegexByCountry = (country) => {
  switch (country) {
    case "AU":
    case "BE":
      return new RegExp(/^\d{4}$/);
    case "CA":
      return new RegExp(/^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/);
    case "DE":
    case "ES":
    case "FR":
      return new RegExp(/^\d{5}$/);
    case "GB":
    case "UK":
      // British Standards document BS 7666
      // https://assets.publishing.service.gov.uk/media/632b07338fa8f53cb77ef6b8/WS02_LRS_Web_Services_Interface_Specification_v6.4.pdf
      return [
        new RegExp(/^[A-Z]{1,2}[0-9R][0-9A-Z]? ?[0-9][ABDEFGHJLNPQRSTUWXYZ]{2}$/),
        new RegExp(/^BFPO ?[0-9]{1,4}$/),
        new RegExp(/^([AC-FHKNPRTV-Y]\d{2}|D6W)? ?[0-9AC-FHKNPRTV-Y]{4}$/),
      ];
    case "IT":
      return new RegExp(/^[0-9]{5}$/);
    case "NL":
      return new RegExp(/^[0-9]{4} ?[A-Z]{2}$/);
    case "US":
      // US zip codes are usually 5 digits and can have an optional "xxxx" or "+xxxx" suffix
      return new RegExp(/^([0-9-]{1,5})(\+?\d{4})?$/);
    default:
      return new RegExp(/^o^/); // matches none
  }
};

/**
 * Returns true if the postalCode for the country short code is valid.
 */
export const isPostalcodeValidForCountry = (country, postalCode) => {
  const reg = postalCodeRegexByCountry(country);
  const match = postalCode.match(reg);
  if(match) return true;
};

